/** Sanitize free-text stake input while the user is typing. */
export function sanitizeStakeInputString(raw: string, allowDecimals: boolean): string {
  const value = String(raw ?? '').replace(/[^0-9.]/g, '')
  if (!allowDecimals) {
    return value.replace(/\./g, '')
  }
  const dotIndex = value.indexOf('.')
  if (dotIndex === -1) {
    return value
  }
  const intPart = value.slice(0, dotIndex + 1)
  const fracPart = value.slice(dotIndex + 1).replace(/\./g, '').slice(0, 2)
  return intPart + fracPart
}

/** Parse a stake string on commit (blur/submit). Returns null when empty or invalid. */
export function parseCommittedStakeInput(raw: string, allowDecimals: boolean): number | null {
  const sanitized = sanitizeStakeInputString(raw, allowDecimals)
  if (sanitized === '' || sanitized === '.') {
    return null
  }
  const parsed = parseFloat(sanitized)
  if (Number.isNaN(parsed) || parsed <= 0) {
    return null
  }
  return parsed
}

/** Stake used for live to-win preview while the field is focused. */
export function parseStakePreviewAmount(raw: string): number {
  const trimmed = String(raw ?? '').trim()
  if (trimmed === '' || trimmed === '.') {
    return 0
  }
  const parsed = parseFloat(trimmed)
  if (Number.isNaN(parsed) || parsed < 0) {
    return 0
  }
  return parsed
}
